import {
    Box,
    Card,
    CardContent,
    CardHeader,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Tooltip,
    Typography,
} from "@mui/material";
import { alpha } from "@mui/material/styles";
import PropTypes from "prop-types";
import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import useAsyncRequest from "src/hooks/useAsyncRequest";
import { useSelector } from "src/store";
import { dateFormat, numberFormat } from "src/utils/dataRenders";

const ExchangeValues = ({ mode }) => {
  const initialized = useRef(null);
  const { currentCustomer } = useSelector((state) => state.customers);
  const { api } = useAsyncRequest();
  const [values, setValues] = useState([]);
  const { t } = useTranslation();

  // const loadValues = async () => {
  //     var res = await api(arkadu.urls.v2.global.exchange.list, {
  //         currency: 'VES'
  //     });
  //     if (res.data.res === 1) {
  //         setValues(res.data.data);
  //     }
  // }
  // useEffect(() => {
  //     if (initialized.current === null) {
  //         initialized.current = true
  //         loadValues();
  //     };

  // }, []);

  if (mode === "topbar") {
    if (!currentCustomer?.currencies?.length) return null;
    const currencies = currentCustomer.currencies
      .filter((c) => c.code !== "PTR" && !c.is_default)
      .sort((a, b) => a.exchange_rate - b.exchange_rate);
    if (!currencies.length) return null;
    const first = currencies[0];
    const others = currencies.slice(1);
    return (
      <Tooltip
        title={
          <Box sx={{ p: 0.25 }}>
            {currencies.map((c) => (
              <Typography key={c.code} variant="caption" sx={{
                display: "block"
              }}>
                <strong>{c.name}:</strong>{" "}
                {numberFormat({ value: 1 / c.exchange_rate })}
              </Typography>
            ))}
            <Typography
              variant="caption"
              sx={{
                display: "block",
                mt: 0.5,
                opacity: 0.7
              }}>
              Fuente BCV al{" "}
              {dateFormat(
                currentCustomer.currencies[0]?.updated ||
                  new Date().toISOString(),
              )}
            </Typography>
          </Box>
        }
        arrow
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 0.5,
            cursor: "default",
            px: 1,
            py: 0.35,
            borderRadius: 1.5,
            border: "1px solid",
            borderColor: "divider",
            bgcolor: (theme) => alpha(theme.palette.background.paper, 0.55),
          }}
        >
          <Typography
            variant="caption"
            sx={{ fontWeight: 600, whiteSpace: "nowrap", lineHeight: 1.3 }}
          >
            <strong>{first.name}</strong>{" "}
            {numberFormat({ value: 1 / first.exchange_rate })}
          </Typography>
          {others.length > 0 && (
            <Typography
              variant="caption"
              color="primary"
              sx={{ fontWeight: 700, lineHeight: 1 }}
            >
              +{others.length}
            </Typography>
          )}
        </Box>
      </Tooltip>
    );
  }

  if (mode === "banner") {
    return (
      <Tooltip
        title={`Fuente BCV al ${dateFormat(
          currentCustomer.currencies[0]?.updated || new Date().toISOString(),
        )}`}
      >
        <Typography
          variant="caption"
          sx={{
            fontSize: {
              xs: "0.65rem",
              sm: "0.85rem",
              md: "1rem",
            },
          }}
        >
          {currentCustomer.currencies
            .filter((c) => c.code !== "PTR" && !c.is_default)
            .sort((a, b) => a.exchange_rate - b.exchange_rate)
            .map((currency, i) => {
              return (
                <React.Fragment key={currency.code}>
                  <strong>{currency.name}:</strong>{" "}
                  {numberFormat({ value: 1 / currency.exchange_rate })}{" "}
                  {i < currentCustomer.currencies.length - 3 ? " | " : ""}
                </React.Fragment>
              );
            })}
        </Typography>
      </Tooltip>
    );
  }
  if (currentCustomer.currencies && mode === "table") {
    return (
      <Card>
        <CardHeader title={`${t("Tipo de cambio (BCV)")} *`} />
        <CardContent>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Moneda</TableCell>
                <TableCell>Bs.</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {currentCustomer.currencies
                .filter((c) => c.code !== "PTR" && !c.is_default)
                .sort((a, b) => a.exchange_rate - b.exchange_rate)
                .map((currency) => {
                  return (
                    <TableRow key={currency.code}>
                      <TableCell>{currency.name}</TableCell>
                      <TableCell>
                        {numberFormat({ value: 1 / currency.exchange_rate })}
                      </TableCell>
                    </TableRow>
                  );
                })}

              <TableRow>
                <TableCell colSpan={2}>
                  <Typography
                    sx={{
                      fontSize: "0.65rem",
                      color: "gray",
                      fontStyle: "italic",
                    }}
                  >
                    *{t("Actualizado")}{" "}
                    {dateFormat(
                      currentCustomer.currencies[0]?.updated ||
                        new Date().toISOString(),
                    )}
                  </Typography>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    );
  }
  return <></>;
};

ExchangeValues.propTypes = {
  mode: PropTypes.oneOf(["table", "banner", "topbar"]),
};
ExchangeValues.defaultProps = {
  mode: "table",
};
export default ExchangeValues;
